import { AxiosCall, CancelTokenSource } from "../axios";

export const getAllServiceLocation = async (
  clinic_group_id: number
): Promise<any> => {
  return AxiosCall.get(
    `/clinic-group/${clinic_group_id}/service-location/all`
  );
};

export const addServiceLocation = async (
  clinic_group_id: number,
  payload: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/clinic-group/${clinic_group_id}/service-location`;

  return AxiosCall.post(url, payload, cancelToken);
};

export const editServiceLocation = async (
  clinic_group_id: number,
  id: number,
  payload: any,
): Promise<any> => {
  const url = `/clinic-group/${clinic_group_id}/service-location/${id}`;

  return AxiosCall.put(url, payload);
};

export const deleteServiceLocation = async (
  clinic_group_id: number,
  id: number
): Promise<any> => {
  return AxiosCall.delete(
    `/clinic-group/${clinic_group_id}/service-location/${id}`
  );
};
